import localforage from "localforage";

/**
 * Set Auth Data
 *
 * @param keyName
 * @param authData
 * @returns AuthObject
 */
export const setAuthData = async (keyName, authData) => {
  try {
    await setItem(keyName, authData);
    const value = await getItem(keyName);
    return JSON.parse(value);
  } catch (err) {
    return authData;
  }
};

/**
 * Get Auth Data
 *
 * @param keyName
 * @param authData
 * @returns AuthObject
 */
export const getAuthData = async () => {
  let authInfo = await getItem("authInfo");
  let authOption = await getItem("authOption");
  return {authInfo,authOption};
};

/**
 * Set Auth Data
 *
 * @param keyName
 * @param authData
 * @returns AuthObject
 */
export const setAuthoritiesData = async (keyName, authorities) => {
  try {
    if(!authorities){
      await setItem(keyName, []);
      return;
    }
    //filter options 
    let optionList  = authorities.filter(auth =>  auth.startsWith('OPT:'));
    if(!optionList){
      await setItem(keyName, []);
    }
    let options = optionList.map(opt => opt.substring(4));
    await setItem(keyName, options);
    return await getItem(keyName);
  } catch (err) {
    console.log('err',err);
    return authorities;
  }
};

/**
 * Agrega un item al store
 *
 * @param key
 * @param value
 * @author lferrer
 */
export const setItem = async (key, value) => {
  await localforage.setItem(key, value).catch((error) => {
    throw new Error("Error en almacenamiento de informacion");
  });
};

/**
 * busca un item al store
 *
 * @param key
 * @author lferrer
 */
export const getItem = async (key) => {
  return await localforage.getItem(key).catch((error) => {
    throw new Error("Error en recuperacion de informacion");
  });
};

/**
 * Elimina un item al store
 *
 * @param key
 * @author lferrer
 */
export const removeItem = async (key) => {
  await localforage.removeItem(key).catch((error) => {
    throw new Error("Error en eliminar la informacion");
  });
};
